import * as React from 'react'
import { FC } from 'react'
import { LoadingSpinner } from '@sales-center/components'
import { useGetCompletionDetailsOnMount } from '@user/store/opportunity'
import { SoldServicesCompletionDetailsCard } from './SoldServicesCompletionDetailsCard'

import Box from '@mui/material/Box'

interface Props {
  opportunityId: number
}

export const SoldServicesCompletionDetailsCardList: FC<Props> = (props) => {
  const { opportunityId } = props

  const { loading, completionDetails } =
    useGetCompletionDetailsOnMount(opportunityId)

  return loading ? (
    <Box m={2}>
      <LoadingSpinner />
    </Box>
  ) : (
    <>
      {completionDetails.map((service, index) => (
        <SoldServicesCompletionDetailsCard
          externalEntityService={service}
          key={index}
        />
      ))}
    </>
  )
}
